export default __webpack_public_path__ + "static/solutions-5544e52b98ecb180ed36f4b4b67a59fa.webp";